import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconAspectRatio169: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconAspectRatio169"><Path d="M1 5V19H23V5H1Z" fill="currentColor"/></CentralIconBase>;
});

export default IconAspectRatio169;
